import DOMPurify from "dompurify";
import { CategoryBadge } from "@/lib/categories";

export { CategoryBadge };

// Renders sanitized HTML post content with editorial typography.
// Styles for the rendered HTML live in index.css under `.post-html`.
export default function PostContent({ html }) {
    const clean = DOMPurify.sanitize(html || "", {
        USE_PROFILES: { html: true },
        ADD_ATTR: ["target", "rel"],
    });
    return (
        <div
            className="post-html"
            data-testid="post-html"
            dangerouslySetInnerHTML={{ __html: clean }}
        />
    );
}
